import type { ExcelColumn } from '../../../utils/excelExport';
import type { AuditLogColumnFilters } from '../models/types';

export const ACCENT_COLORS = [
  '#5c6bc0', '#26a69a', '#ffa502', '#ff6b6b', '#a78bfa', '#2ed573', '#ff9f43',
];

export const SEARCH_DEBOUNCE_MS = 400;

export const EMPTY_AUDIT_LOG_COLUMN_FILTERS: AuditLogColumnFilters = {
  userName: null,
  userType: null,
  action: null,
  entityName: null,
  recordId: null,
  ipAddress: null,
  createdAt: null,
};

export const AUDIT_LOG_EXPORT_COLUMNS: ExcelColumn[] = [
  { header: 'User Name', key: 'userName' },
  { header: 'User Type', key: 'userType' },
  { header: 'Action', key: 'action' },
  { header: 'Entity', key: 'entityName' },
  { header: 'Record ID', key: 'recordId' },
  { header: 'Description', key: 'description' },
  { header: 'IP Address', key: 'ipAddress' },
  { header: 'Timestamp', key: 'createdAt' },
];
